export default "__VITE_ASSET__DE0a9MQ$__"